import { BottomTabNavigationProp } from '@react-navigation/bottom-tabs'
import {
  CompositeNavigationProp,
  ParamListBase,
} from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { Button, Colors, Icon, Theme } from '@rneui/themed'
import { ConversationTabParamList } from 'chat/conversations/types'
import { FileFoldersBottomTabParamList } from 'file_folder_repository/chat_group_folders/stack/types'
import { HomeStackParamList } from 'home/stack/types'
import React from 'react'
import { ActivityIndicator, Platform, View } from 'react-native'

type Position = 'left' | 'right'

export function showHeaderButton<
  ParamList extends ParamListBase,
  RouteName extends keyof ParamList
>({
  navigation,
  theme,
  title,
  iconType = 'ionicon',
  onPress,
  position = 'right',
  useIcon,
  disabled = false,
  loading = false,
}: {
  navigation:
    | StackNavigationProp<ParamList, RouteName>
    | CompositeNavigationProp<
        | BottomTabNavigationProp<ConversationTabParamList>
        | BottomTabNavigationProp<FileFoldersBottomTabParamList>,
        StackNavigationProp<HomeStackParamList>
      >
  theme: {
    colors: Colors
  } & Theme
  title: string | undefined
  iconType?: string
  onPress: () => void
  position?: Position
  useIcon?: boolean
  disabled?: boolean
  loading?: boolean
}) {
  if (position === 'left' && Platform.OS !== 'ios') {
    return
  }

  const header = position === 'left' ? 'headerLeft' : 'headerRight'

  navigation.setOptions({
    ...(position === 'right' && {
      headerRightContainerStyle: title
        ? { minWidth: 52, flexShrink: 0 }
        : undefined,
    }),
    [header]: () =>
      title && (
        <View style={{ marginRight: 0 }}>
          {useIcon ? (
            loading ? (
              <ActivityIndicator
                style={{ marginRight: 10 }}
                color={theme.colors?.primary}
              />
            ) : (
              <Icon
                name={title}
                type={iconType}
                color={theme.colors?.primary}
                onPress={onPress}
                disabled={disabled}
                style={{ marginRight: 10 }}
              />
            )
          ) : (
            <Button
              title={title}
              buttonStyle={{
                backgroundColor: 'transparent',
                padding: 0,
              }}
              disabledStyle={{ backgroundColor: 'transparent' }}
              titleStyle={{
                color: theme.colors?.primary,
                fontSize: 17,
                letterSpacing: 0.35,
                fontFamily: 'System',
              }}
              titleProps={{ allowFontScaling: false }}
              onPress={onPress}
              disabled={disabled}
              loading={loading}
              loadingProps={{ size: 'small', color: theme.colors.primary }}
              loadingStyle={{ paddingRight: 10 }}
            />
          )}
        </View>
      ),
  })
}
